import React, { useState } from "react";
import { COLORS } from "./constants/colors";
import { useDarkMode } from "./hooks/useDarkMode";
import { GlobalStyles } from "./styles/GlobalStyles";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";

// Pages
import { HomePage } from "./pages/HomePage";
import { ProjectsPage } from "./pages/ProjectsPage";
import { AboutPage } from "./pages/AboutPage";
import { SkillsPage } from "./pages/SkillsPage";
import { ContactPage } from "./pages/ContactPage";

export default function App() {
  const { isDark, toggle } = useDarkMode();
  const [currentPage, setCurrentPage] = useState("Home");

  const c = isDark ? COLORS.dark : COLORS.light;

  const pageComponent = {
    Home: <HomePage c={c} isDark={isDark} setPage={setCurrentPage} />,
    Projects: <ProjectsPage c={c} isDark={isDark} />,
    About: <AboutPage c={c} isDark={isDark} />,
    Skills: <SkillsPage c={c} isDark={isDark} />,
    Contact: <ContactPage c={c} isDark={isDark} />,
  }[currentPage];

  return (
    <div style={{
      fontFamily: "'Geist', sans-serif",
      background: c.background,
      color: c.onSurface,
      minHeight: "100vh",
      transition: "background 0.3s, color 0.3s",
    }}>
      <GlobalStyles />

      <Navbar
        currentPage={currentPage}
        setPage={setCurrentPage}
        isDark={isDark}
        toggleDark={toggle}
        c={c}
      />

      <main key={currentPage} className="fade-in">
        {pageComponent}
      </main>

      <Footer c={c} isDark={isDark} setPage={setCurrentPage} />
    </div>
  );
}